module.exports = __webpack_public_path__ + "img/header-engagementRingsFastDelivery@2x.aaa08e8.jpg";